'use client';

import Link from 'next/link';
import type { Category } from '@/types/catalog';

const PALETTES: Array<[string, string]> = [
  ['#0F2447', '#F1ECE0'],
  ['#7A1F22', '#F1ECE0'],
  ['#2A4D3E', '#F1ECE0'],
  ['#3D2E4A', '#E8D9B4'],
  ['#1B2D4A', '#E8D9B4'],
  ['#6B2E1F', '#F1ECE0'],
];

export function CategoryCard({ cat }: { cat: Category }) {
  const p = PALETTES[Math.abs(cat.slug.charCodeAt(0)) % PALETTES.length];

  return (
    <Link
      href={`/coleccion/${cat.slug}`}
      className="cat-card"
      style={{
        display: 'block',
        padding: '36px 28px 28px',
        background: p[0],
        color: p[1],
        borderRadius: 2,
        textDecoration: 'none',
        minHeight: 200,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div className="eyebrow" style={{ color: p[1], opacity: 0.7 }}>Colección</div>
      <div className="serif" style={{ fontSize: 30, marginTop: 14, lineHeight: 1.1, letterSpacing: '-0.01em', maxWidth: '85%' }}>
        {cat.name}
      </div>
      <div style={{ marginTop: 14, fontSize: 13, opacity: 0.78, maxWidth: 320 }}>{cat.description}</div>
      <div
        style={{
          position: 'absolute',
          right: 24,
          bottom: 22,
          fontFamily: 'var(--mono)',
          fontSize: 11,
          opacity: 0.7,
          letterSpacing: '0.08em',
        }}
      >
        {cat.count} títulos
      </div>
      <style>{`.cat-card { transition: transform 220ms ease; } .cat-card:hover { transform: translateY(-2px); }`}</style>
    </Link>
  );
}
